export default "__VITE_ASSET__BgKMu3O7__"